import React from 'react';
import { GridItem, FormCell, RadioSwitch } from 'ui-toolkit';
import { IPartySchema } from 'state';
import { Field } from 'formik';
import { DisplayPartyType, ePartyType } from '../../../../../ui-toolkit/enums/ePartyType';
import { IFieldChildProps } from '../../../../../ui-toolkit/utilities/formikUtilities';

export interface IPartyTypeSelectorProps {
  onPartyTypeChange: () => void;
}

export const PartyTypeSelector: React.FC<IPartyTypeSelectorProps> = ({ onPartyTypeChange }) => {
  const myOnPartyTypeChange = ({ field, form }: IFieldChildProps<ePartyType, IPartySchema>) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      form.setFieldValue(`signatories`, []);
      form.setFieldValue(field.name, event.target.value);
      form.setFieldTouched(field.name, true);
      onPartyTypeChange();
    };
  };
  const typeOptions = [
    { label: DisplayPartyType[ePartyType.person], value: ePartyType.person },
    { label: DisplayPartyType[ePartyType.entity], value: ePartyType.entity },
  ];
  return (
    <>
      <GridItem columnStart={'span 6'}>
        <Field
          name={`type`}
          render={({ field, form, meta }: IFieldChildProps<ePartyType, IPartySchema>) => (
            <FormCell>
              <RadioSwitch {...field} onChange={myOnPartyTypeChange({ form, field, meta })} options={typeOptions} />
            </FormCell>
          )}
        />
      </GridItem>
      <GridItem columnStart={'span 6'} />
    </>
  );
};
